<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <span>Bayaran</span>
                </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Sejarah Bayaran</h2>
                <p class="page-subtitle">Rekod pembayaran yuran dan ujian</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-lg-6">
                    
                    <div class="collapsible-list">
                        
                        <!-- YURAN Section -->
                        <div class="collapsible-card">
                            <div class="collapsible-header" 
                                 :class="{ 'collapsed': !yuranOpen }"
                                 @click="yuranOpen = !yuranOpen">
                                <div class="collapsible-title">
                                    <i class="fas fa-money-bill-wave"></i>
                                    <span>Yuran</span>
                                </div>
                                <div class="collapsible-meta">
                                    <span class="collapsible-count">{{ yurans.length }} Semester</span>
                                    <i class="fas fa-chevron-down collapsible-toggle"></i>
                                </div>
                            </div>
                            <div class="collapsible-body" v-show="yuranOpen">
                                <div class="list-item" v-for="(item, index) in yurans" :key="index">
                                    <div class="list-item-header">
                                        <span class="list-item-number">{{ index + 1 }}</span>
                                        <div class="list-item-info">
                                            <span class="list-item-name">{{ item.term }}/{{ item.academic_year }}</span>
                                            <span class="score-badge" :class="getPaymentClass(item.pay_status)">
                                                <i :class="getPaymentIcon(item.pay_status)"></i>
                                                {{ item.pay_status }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="list-item-details" v-if="item.yuran && item.yuran.length">
                                        <div class="payment-record" v-for="(yuran, idx) in item.yuran" :key="idx">
                                            <div class="detail-row">
                                                <i class="fas fa-coins"></i>
                                                <span><strong>{{ yuran.money | numFormat(0,0) }} ฿</strong></span>
                                            </div>
                                            <div class="detail-row">
                                                <i class="fas fa-calendar"></i>
                                                <span>{{ yuran.pay_date | thaiDate }}</span>
                                            </div>
                                            <div class="detail-row">
                                                <i class="fas fa-user"></i>
                                                <span>{{ yuran.name }} {{ yuran.lastname }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="yurans.length === 0" class="empty-state-sm">
                                    <i class="fas fa-inbox"></i>
                                    <p>Tiada rekod yuran</p>
                                </div>
                            </div>
                        </div>

                        <!-- UJIAN Section -->
                        <div class="collapsible-card">
                            <div class="collapsible-header" 
                                 :class="{ 'collapsed': !examOpen }"
                                 @click="examOpen = !examOpen">
                                <div class="collapsible-title">
                                    <i class="fas fa-file-invoice-dollar"></i>
                                    <span>Ujian</span>
                                </div>
                                <div class="collapsible-meta">
                                    <span class="collapsible-count">{{ exams.length }} Rekod</span>
                                    <i class="fas fa-chevron-down collapsible-toggle"></i>
                                </div>
                            </div>
                            <div class="collapsible-body" v-show="examOpen">
                                <div class="list-item" v-for="(item, index) in exams" :key="index">
                                    <div class="list-item-header">
                                        <span class="list-item-number">{{ index + 1 }}</span>
                                        <div class="list-item-info">
                                            <span class="list-item-name">{{ item.term }}/{{ item.year }}</span>
                                            <span class="score-badge" :class="getPaymentClass(item.pay_status)">
                                                <i :class="getPaymentIcon(item.pay_status)"></i>
                                                {{ item.pay_status }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="list-item-details" v-if="item.pay_date">
                                        <div class="detail-row">
                                            <i class="fas fa-coins"></i>
                                            <span><strong>{{ item.money | numFormat(0,0) }} ฿</strong></span>
                                        </div>
                                        <div class="detail-row">
                                            <i class="fas fa-calendar"></i>
                                            <span>{{ item.pay_date | thaiDate }}</span>
                                        </div>
                                        <div class="detail-row">
                                            <i class="fas fa-user"></i>
                                            <span>{{ item.name }} {{ item.lastname }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="exams.length === 0" class="empty-state-sm">
                                    <i class="fas fa-inbox"></i>
                                    <p>Tiada rekod ujian</p>
                                </div>
                            </div>
                        </div>

                        <!-- PEMBANGUNAN AKADEMIK Section -->
                        <div class="collapsible-card">
                            <div class="collapsible-header info" 
                                 :class="{ 'collapsed': !akademikOpen }"
                                 @click="akademikOpen = !akademikOpen">
                                <div class="collapsible-title">
                                    <i class="fas fa-university"></i>
                                    <span>Pembangunan Akademik</span>
                                </div>
                                <div class="collapsible-meta">
                                    <i class="fas fa-chevron-down collapsible-toggle"></i>
                                </div>
                            </div>
                            <div class="collapsible-body" v-show="akademikOpen">
                                <div class="empty-state-sm">
                                    <i class="fas fa-tools"></i>
                                    <p>Dalam pembangunan</p>
                                </div>
                            </div>
                        </div>

                        <!-- MUSTAWA BAHASA ARAB Section -->
                        <div class="collapsible-card">
                            <div class="collapsible-header info" 
                                 :class="{ 'collapsed': !mustawaOpen }"
                                 @click="mustawaOpen = !mustawaOpen">
                                <div class="collapsible-title">
                                    <i class="fas fa-language"></i>
                                    <span>Mustawa Bahasa Arab</span>
                                </div>
                                <div class="collapsible-meta">
                                    <i class="fas fa-chevron-down collapsible-toggle"></i>
                                </div>
                            </div>
                            <div class="collapsible-body" v-show="mustawaOpen">
                                <div class="empty-state-sm">
                                    <i class="fas fa-tools"></i>
                                    <p>Dalam pembangunan</p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        mounted(){
            this.retreiveYuranHistories()
            this.retrievExamPaymentHistories()
        },
        data(){
            return {
                yuranOpen: false,
                examOpen: false,
                akademikOpen: false,
                mustawaOpen: false
            }
        },
        computed:{
            ...mapState('paymentYuran', [
                'yurans'
            ]),
            ...mapState('paymentExam', [
                'exams'
            ])
        },
        methods:{
            getPaymentClass(status) {
                if (status == 'Belum bayar') return 'danger'
                if (status == 'BELUM LUNAS') return 'warning'
                return 'success'
            },
            getPaymentIcon(status) {
                if (status == 'Belum bayar') return 'fas fa-times-circle'
                if (status == 'BELUM LUNAS') return 'fas fa-exclamation-circle'
                return 'fas fa-check-circle'
            },
            retrievExamPaymentHistories(){
                this.$store.dispatch("paymentExam/retreiveExamPayment")
                    .then(() => {})
                    .catch(() => {})
            },
            retreiveYuranHistories(){
                this.$Progress.start()
                this.$store.dispatch("paymentYuran/retreiveYuranHistories")
                    .then(response => {
                        this.$Progress.finish();
                        this.yuran = response.data.payments
                    })
                    .catch(error => {
                        if(error.response.status == 401 || error.response.status == 419){
                            this.$store.dispatch("authentication/cencelAuthen")
                        }
                        this.$Progress.fail();
                        console.log(error)
                    })
            }
        }
    }
</script>

<style scoped>
.payment-record {
    padding: 12px;
    background: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 8px;
}

.payment-record:last-child {
    margin-bottom: 0;
}
</style>